<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
.card{padding: 15px !important;}
.main-sidebar{z-index: 0 !important;}

@media (max-width: 991.98px){
  .sidebar-open .main-sidebar, .sidebar-open .main-sidebar:before{z-index: 1900 !important}
}
</style>



// WEBPACK FOOTER //
// src/App.vue